/*
    * Computed properties
*/
import Vue from 'vue';
import moment from 'moment';
import * as _ from 'lodash';
import { MutationTree } from "vuex";
import { AppConstants as _app } from "@/shared/app.constants";

export const mutations: MutationTree<any> = {
    /*
        * Downloaded form data for a card from server.
    */
    _muDownload(state, data) {
        try {
            //#.loadingRecords are triggered with the store.dispatch method.
            // @ts-ignore
            this.dispatch(data.payload.fileName + '/loadingRecords', { state: state, data: data.result });

            let context = state[data.payload.fileName];
            state[data.payload.fileName].fields = state[data.payload.fileName].orgFields;

            //# Find module title index
            let index = _.findIndex(data.payload.dashboard.cards, function (index) {
                return index === data.payload.moduleName;
            });

            data.payload.title = data.payload.dashboard.title[index];
            data.payload.orginTitle = data.payload.title;
            data.payload.index = index;

            if (_.includes(data.payload.title, '{{')) {
                let title = data.payload.title.substr(2).slice(0, -2);
                let tooltip = data.payload.headerTooltip;

                if (data.payload.fields[title])
                    data.payload.headerMaxLength = data.payload.fields[title].maxLength;

                if (data.payload.orgFields[title] && data.payload.orgFields[title].required) {
                    data.payload.required = true;
                }

                if (data.payload.fields[title])
                    tooltip = (data.payload.fields[title].title == undefined ? data.payload.fields[title].value : data.payload.fields[title].title);

                if (data.payload.titleSearch == null)
                    data.payload.titleSearch = true;

                if (data.payload.titleSearch) {
                    data.payload.headerTooltip = tooltip;
                }

                delete data.payload.fields[title];
            }

            data.payload.formData = {};
            state[data.payload.fileName].editedItem = {};
            state[data.payload.fileName].exportableFields = {};
            state[data.payload.fileName].xlsxColumns = [];
            data.payload.org = state[data.payload.fileName].fields;

            if (data.payload.card.type == data.payload.type._form)
                data.payload.formData = data.result.Record[0];
            else
                data.payload.formData = data.result.Record;

            if (data.payload.card.type == data.payload.type._tree && data.payload.autoOpen) {
                if (data.result.AutoOpen.length > 0) {
                    data.payload.autoOpenItems = data.result.AutoOpen;
                }
            }

            //#. Grouping option
            if (data.payload.grouping.enabled) {
                for (var i = 0; i < data.payload.formData.length; i++) {
                    data.payload.formData[i]["hide"] = false;

                    if (data.payload.grouping.collapse) {
                        data.payload.formData[i]["hide"] = true;
                    } else {
                        data.payload.formData[i]["hide"] = false;
                    }

                    if (data.payload.grouping.defaultGroupBy)
                        data.payload.grouping.title = data.payload.fields[data.payload.grouping.defaultGroupBy].title;

                    data.payload.formData[i]["_groupId"] = i;
                }
            }

            state.dashboard.mobileAppName = data.payload.fileName;

            //# Add button list in mobile app
            if (state.dashboard.mobileApp && state[data.payload.fileName].buttonList) {
                let buttons = Object.keys(state[data.payload.fileName].buttonList);

                if (data.result.UserRigts.indexOf('A') == -1 || state[data.payload.fileName].hideButtons.indexOf('Add') != -1) {
                    state.dashboard.buttonList = {};
                }

                for (var i = 0; i < buttons.length; i++) {
                    let name = buttons[i];
                    state.dashboard.buttonList[name] = state[data.payload.fileName].buttonList[name];
                }
            }

            //#. Tooltip options.
            data.payload.tooltipsList = [];
            data.payload.tooltipsFormData = [];

            var tooltips = Object.keys(data.payload.tooltip.fields).map(val => {
                let record: any = {};
                record = data.payload.tooltip.fields[val];
                record.value = val;
                record.text = data.payload.tooltip.fields[val].title;

                return record;
            });

            //#. Tooltip edit options.
            tooltips.push({ value: 'ButtonAction', type: 'Button', text: '' });
            data.payload.tooltip.headers = tooltips;

            if (data.payload.card.type != data.payload.type._tree) {
                let indexVal = 0, tooltipIndex = 0, toolIndex = 0;

                var result = Object.keys(data.payload.fields).map(val => {
                    let record: any = {},
                        tooltips = data.payload.dashboard.tooltip[data.payload.index];
                    record = data.payload.fields[val];
                    record.value = val;
                    record.defaultTooltip = data.payload.fields[val].tooltip;
                    record.text = data.payload.fields[val].title;

                    if (tooltips != null && tooltips != "") {
                        let fieldTooltip = JSON.parse(tooltips);
                        record.tooltip = (fieldTooltip[val] == undefined) ? record.tooltip : fieldTooltip[val];
                    }

                    //#.Tooltip
                    if (record.tooltip) {
                        data.payload.tooltipsList[toolIndex] = {};
                        data.payload.tooltipsList[toolIndex]['key'] = record.text;
                        data.payload.tooltipsList[toolIndex]['value'] = record.tooltip;
                        toolIndex++;
                    }

                    //#.Tooltip edit option
                    if (data.payload.fields[val].type != 'Hidden' && data.payload.fields[val].parent != true && data.payload.fields[val].primaryKey != true) {
                        data.payload.tooltipsFormData[tooltipIndex] = {};
                        data.payload.tooltipsFormData[tooltipIndex]["FieldName"] = (record.text == undefined) ? val : record.text;
                        data.payload.tooltipsFormData[tooltipIndex]["Description"] = record.tooltip;
                        tooltipIndex++;
                    }

                    if (state[data.payload.fileName].exportOption && !data.payload.fields[val].primaryKey && !data.payload.fields[val].parent
                        && data.payload.fields[val].exportable != false) {
                        state[data.payload.fileName].exportableFields[data.payload.fields[val].title] = {};
                        state[data.payload.fileName].exportableFields[data.payload.fields[val].title] = record.value;
                        //#.Xlsx columns
                        state[data.payload.fileName].xlsxColumns[indexVal] = {};
                        state[data.payload.fileName].xlsxColumns[indexVal]["label"] = record.text;
                        state[data.payload.fileName].xlsxColumns[indexVal]["field"] = record.value;
                        indexVal++;
                    }

                    if (data.payload.fields[val].type == 'MultiSelect' || data.payload.fields[val].type == 'CheckboxList') {
                        /*let name = '';
                        let id = (data.payload.formData == undefined) ? (record.defaultValue == undefined ? -1 : record.defaultValue) : data.payload.formData[val];

                        for (var i = 0; i < data.payload.formData.length; i++) {
                            if (data.payload.formData[i][val] || data.payload.formData[i][val] == 0)
                                id = data.payload.formData[i][val];
                            else
                                id = (record.defaultValue == undefined) ? null : record.defaultValue;

                            if (id != null) {
                                let idArr = id.split(",").map((x: any) => parseInt(x, 10));
                                // @ts-ignore
                                _.forOwn(data.result[val].Result["Value"].Record, function (key, val) {
                                    // if (key.Value == id) {
                                    if(idArr.indexOf(key.Value) != -1) {
                                        name = key.DisplayText;
                                        record.select = { DisplayText: name, Value: key.Value };
                                        return;
                                    }

                                    if (key.Value == record.defaultValue) {
                                        name = key.DisplayText;
                                        record.select = { DisplayText: name, Value: key.Value };
                                        return;
                                    }
                                });
                                data.payload.formData[i][val] = name;
                            }
                        }*/
                        record.dropdown = data.result[val].Result["Value"].Record;
                        if (data.payload.card.type == data.payload.type._grid && data.payload.fields[val].type == 'MultiSelect') {
                            for (var i = 0; i < data.payload.formData.length; i++) {
                                let id, name = '', result = [];
                                if (data.payload.formData[i][val] || data.payload.formData[i][val] == 0)
                                    id = data.payload.formData[i][val];

                                if (id != null) {
                                    _.forOwn(data.result[val].Result["Value"].Record, function (key, val) {
                                        if (id.split(",").includes(key.Value.toString())) {
                                            result.push(key.DisplayText);
                                            return;
                                        }
                                    });

                                    for (var j = 0; j < result.length; j++) {
                                        if (j == 0) {
                                            name = result[j];
                                        }
                                        else if (j > 0) {
                                            name = name + ", " + result[j];
                                        }
                                    }
                                    data.payload.formData[i][val] = name;
                                }
                            }
                        }
                    } else if (data.payload.fields[val].type == 'ComboBox' || data.payload.fields[val].type == 'RadioButtonList') {
                        //#. List out the all workflow steps...
                        if (data.payload.parentComponent && data.payload.fields[val].value == state.workflow.workflowStepId) {
                            state.workflow.log = data.result[val].Result["Value"].List.Result.Value.Log;
                            record.dropdownList = data.result[val].Result["Value"].List.Result.Value.Record;
                        }

                        record.dropdown = data.result[val].Result["Value"].Record;
                        //#.Checking workflow implemenation.
                        if (val == state.workflow.workflowStepId && data.payload.card.type == data.payload.type._grid) {
                            data.result[val].Result["Value"].Record = data.result[val].Result["Value"].List.Result.Value.Record;
                        }

                        let name = '';
                        let id = (data.payload.formData == undefined) ? (record.defaultValue == undefined ? -1 : record.defaultValue) : data.payload.formData[val];

                        if (data.payload.formData && data.payload.formData.length == 0) {
                            id = (record.defaultValue == undefined) ? -1 : record.defaultValue;
                            // @ts-ignore
                            _.forOwn(data.result[val].Result["Value"].Record, function (key, val) {
                                if (key.Value == id) {
                                    name = key.DisplayText;
                                    return;
                                }
                            });

                            record.select = { DisplayText: name, Value: id };
                        }

                        if (data.payload.card.type == data.payload.type._form) {
                            // @ts-ignore
                            _.forOwn(data.result[val].Result["Value"].Record, function (key, val) {
                                if (key.Value == id) {
                                    name = key.DisplayText;
                                    return;
                                }
                            });
                            record.select = { DisplayText: name, Value: id };
                        } else if (data.payload.card.type == data.payload.type._treeTable) {
                            for (var i = 0; i < data.payload.formData.length; i++) {
                                if (data.payload.formData[i][val] || data.payload.formData[i][val] == 0)
                                    id = data.payload.formData[i][val];
                                else
                                    id = (record.defaultValue == undefined) ? null : record.defaultValue;

                                if (id != null || id == 0) {
                                    // @ts-ignore
                                    _.forOwn(data.result[val].Result["Value"].Record, function (key, val) {
                                        if (key.Value == id) {
                                            name = key.DisplayText;
                                            record.select = { DisplayText: name, Value: key.Value };
                                            return;
                                        }

                                        if (key.Value == record.defaultValue) {
                                            name = key.DisplayText;
                                            record.select = { DisplayText: name, Value: key.Value };
                                            return;
                                        }
                                    });
                                    data.payload.formData[i][val] = name;
                                    data.payload.formData[i][val + '_select'] = id;
                                }
                                this.commit('_muRecurseComboBox', { parent: data.payload.formData[i], data: data, record: record, fieldName: val });
                            }
                        } else {
                            for (var i = 0; i < data.payload.formData.length; i++) {
                                if (data.payload.formData[i][val] || data.payload.formData[i][val] == 0)
                                    id = data.payload.formData[i][val];
                                else
                                    id = (record.defaultValue == undefined) ? null : record.defaultValue;

                                if (id != null) {
                                    // @ts-ignore
                                    _.forOwn(data.result[val].Result["Value"].Record, function (key, val) {
                                        name = "";
                                        
                                        if (key.Value == id) {
                                            name = key.DisplayText;
                                            record.select = { DisplayText: name, Value: key.Value };
                                            return false;
                                        }

                                        if (data.payload.card.type != "Grid" && key.Value == record.defaultValue) {
                                            name = key.DisplayText;
                                            record.select = { DisplayText: name, Value: key.Value };
                                            return false;
                                        }
                                    });
                                    data.payload.formData[i][val] = name;
                                }
                            }
                        }
                    } else if (data.payload.fields[val].type == 'Date') {
                        if (data.payload.formData && data.payload.formData[val] != "" && data.payload.formData[val] != null) {
                            data.payload.formData[val] = moment(data.payload.formData[val]).format(data.payload.defaultDateFormat);
                            record.date = data.payload.formData[val];

                            if (data.payload.fields[val].displayFormat) {
                                data.payload.formData[val] = moment(data.payload.formData[val], data.payload.defaultDateFormat).format(record.displayFormat);
                            }
                        } else if (data.payload.card.type == data.payload.type._treeTable && data.payload.formData && data.payload.formData.length > 0) {
                            let _self = this;
                            // @ts-ignore
                            _.forOwn(data.payload.formData, function (key, val) {
                                if (key[record.value]) {
                                    key[record.value] = moment(key[record.value]).format(data.payload.defaultDateFormat);

                                    if (record.displayFormat) {
                                        key[record.value] = moment(data.payload.formData[val][record.value]).format(record.displayFormat);
                                    }
                                }
                                _self.commit('_muRecurseDate', { parent: key, record: record });
                            });
                        } else if (data.payload.formData && data.payload.formData.length > 0) {
                            // @ts-ignore
                            _.forOwn(data.payload.formData, function (key, val) {
                                if (key[record.value]) {
                                    key[record.value] = moment(key[record.value]).format(data.payload.defaultDateFormat);
                                    record.date = key[record.value];

                                    if (record.displayFormat) {
                                        key[record.value] = moment(data.payload.formData[val][record.value]).format(record.displayFormat);
                                    }
                                    return;
                                }
                            });
                        }
                    } else if (data.payload.fields[val].type == 'DateWithTime') {
                        if (data.payload.formData && data.payload.formData[val] != "" && data.payload.formData[val] != null) {
                            data.payload.formData[val] = moment(data.payload.formData[val]).format(data.payload.defaultDateWithTime);
                            record.date = data.payload.formData[val];

                            if (data.payload.fields[val].displayFormat) {
                                data.payload.formData[val] = moment(data.payload.formData[val]).format(record.displayFormat);
                            }
                        } else if (data.payload.card.type == data.payload.type._treeTable && data.payload.formData && data.payload.formData.length > 0) {
                            let _self = this;
                            // @ts-ignore
                            _.forOwn(data.payload.formData, function (key, val) {
                                if (key[record.value]) {
                                    key[record.value] = moment(key[record.value]).format(data.payload.defaultDateWithTime);

                                    if (record.displayFormat) {
                                        key[record.value] = moment(data.payload.formData[val][record.value]).format(record.displayFormat);
                                    }
                                }
                                _self.commit('_muRecurseDate', { parent: key, record: record });
                            });
                        } else if (data.payload.formData && data.payload.formData.length > 0) {
                            // @ts-ignore
                            _.forOwn(data.payload.formData, function (key, val) {
                                if (key[record.value]) {
                                    key[record.value] = moment(key[record.value]).format(data.payload.defaultDateWithTime);
                                    record.date = key[record.value];

                                    if (record.displayFormat) {
                                        key[record.value] = moment(data.payload.formData[val][record.value]).format(record.displayFormat);
                                    }
                                    return;
                                }
                            });
                        }

                    } else if (data.payload.fields[val].type == 'Number' && data.payload.fields[val].currency) {
                        if (data.payload.formData && data.payload.formData[val] != "" && data.payload.formData[val] != null) {
                            // TO DO: bring local region to the component                            
                            data.payload.formData[val] = new Intl.NumberFormat(_app.region.default, {
                                style: 'decimal',        
                                minimumFractionDigits: (record.currency.precision == undefined ? 2 : record.currency.precision)
                            }).format(data.payload.formData[val]);                       
                            
                        } else if (data.payload.card.type == data.payload.type._treeTable && data.payload.formData && data.payload.formData.length > 0) {
                            let _self = this;
                            // @ts-ignore
                            _.forOwn(data.payload.formData, function (key, val) {
                                if (key[record.value] != null && key[record.value] != undefined) {
                                    // TO DO: bring local region to the component
                                    const formatter = new Intl.NumberFormat(_app.region.default, {
                                        style: 'decimal',
                                        //currency: currencyFormat,
                                        minimumFractionDigits: (record.currency.precision == undefined ? 2 : record.currency.precision)
                                    });
                                    key[record.value] = formatter.format(key[record.value]);
                                }
                                // self.commit('_muRecurseNumber', { parent: key, record: record });
                            });
                        } else if (data.payload.formData && data.payload.formData.length > 0) {
                            // @ts-ignore
                            _.forOwn(data.payload.formData, function (key, val) {
                                // TO DO: bring local region to the component
                                if (key[record.value] != null && key[record.value] != undefined) {
                                    const formatter = new Intl.NumberFormat(_app.region.default, {
                                        style: 'decimal',
                                        //currency: currencyFormat,
                                        minimumFractionDigits: (record.currency.precision == undefined ? 2 : record.currency.precision)
                                    });

                                    key[record.value] = formatter.format(key[record.value]);
                                    return;
                                }
                            });
                        }
                    }

                    state[data.payload.fileName].editedItem[val] = "";

                    if (record.defaultValue) {
                        state[data.payload.fileName].editedItem[val] = record.select;
                    }

                    if (data.payload.fields[val].type == 'RadioButtonList' && record.defaultValue) {
                        state[data.payload.fileName].editedItem[val] = record.select.Value;
                    }

                    if (data.payload.fields[val].type == 'SwitchInput' && record.defaultValue) {
                        state[data.payload.fileName].editedItem[val] = record.defaultValue;
                    }

                    if (data.payload.fields[val].displayCurrentDate && (record.date == undefined || state[data.payload.fileName].editedItem[val] == "" || data.payload.card.type == data.payload.type._grid)) {
                        let dateFormat = data.payload.fields[val].type == 'DateWithTime' ? context.defaultDateWithTime :  context.defaultDateFormat;
                        state[data.payload.fileName].editedItem[val] = moment(new Date).format(dateFormat);

                        record.date = state[data.payload.fileName].editedItem[val];
                        record.currentDate = moment(new Date).format(dateFormat);

                        if (data.payload.fields[val].displayFormat) {
                            state[data.payload.fileName].editedItem[val] = moment(new Date).format(record.displayFormat);
                        }
                    }
                    return record;
                });
                state[data.payload.fileName].defaultItem = state[data.payload.fileName].editedItem;
                data.payload.fields = result;
                state[data.payload.fileName].headers = data.payload.fields.filter(x => (x.primaryKey != true && x.parent != true && x.list != false && x.type != 'Hidden' && x.type != 'button' && x.type != 'Button') || ((x.type == 'button' || x.type == 'Button') && x.title != undefined));

                //#.Show row number feature
                if (state[data.payload.fileName].showRowNumber) {
                    if (state[data.payload.fileName].grouping.enabled)
                        state[data.payload.fileName].showRowNumber = false;
                    else
                        state[data.payload.fileName].headers.unshift({ text: '#', sortable: false });
                }

                //#.Child table feature
                if (state[data.payload.fileName].childTables) {
                    state[data.payload.fileName].child = {};
                    state[data.payload.fileName].child.isExpanded = false;
                    state[data.payload.fileName].child.childIndex = -1;
                    state[data.payload.fileName].child.childContext = null;

                    _.forOwn(state[data.payload.fileName].childTables, function (key, val) {

                        if (key.title)
                            state[data.payload.fileName].headers.unshift({ text: key.tooltip, sortable: false, align: 'center' });
                        else
                            state[data.payload.fileName].headers.unshift({ text: '', sortable: false });
                    });
                }

                //#.Tree table - The corresponding value will be shown in the column for the given row property.
                if (data.payload.card.type == data.payload.type._treeTable) {
                    _.forOwn(state[data.payload.fileName].headers, function (obj, i) {
                        obj.filterable = true;
                        obj.property = obj.value;
                    });
                }

                //#.Auto create an empty row if inline editor empty row annotation is enabled
                if (context.inlineEditor.enabled && context.inlineEditor.emptyRow) {
                    //#.Header th add based on the permission.
                    if (data.payload.card.type == data.payload.type._grid) {
                        if (state[data.payload.fileName].headers.filter(x => x.type == 'Number').length > 0) {
                            state[data.payload.fileName].headers.filter(x => x.type == 'Number').forEach(key => {
                                if (!key["align"])
                                    key["align"] = 'right';
                            });
                        }

                        state[data.payload.fileName].headers.push({ value: 'ButtonAction', type: 'Button', sortable: false })
                    }

                    //#.Empty row enabled based on the permission.
                    if (data.result.UserRigts.indexOf('A') == -1) {
                        context.inlineEditor.emptyRow = false;
                        return;
                    }

                    let defaultRowData = {};

                    //#.Find the current operation
                    context.formCreate = true;

                    //#.Enable the disabled fields
                    context.disabled = false;

                    //#.Enable the disabled save button
                    context.buttonDisabled = false;

                    //#.Reset all the default values in fields
                    context.fields.filter(x => x.list != false && x.type != 'Hidden').forEach(key => {
                        defaultRowData[key.value] = context.defaultItem[key.value];

                        if (context.defaultItem[key.value] && key.displayCurrentDate)
                            return;

                        if (context.defaultItem[key.value] && !key.defaultValue)
                            defaultRowData[key.value] = null;
                    });

                    //#.Adding empty row to records based on pagination
                    let emptyRowTempData = [];

                    _.forOwn(context.formData, function (key, val: any) {
                        if (context.pagination.pageSize != -1 && context.pagination.pageSize - 1) {
                            if (context.formData.length > (context.pagination.pageSize - 1)) {
                                // @ts-ignore
                                if ((context.pagination.pageSize - 1) == val) {
                                    // @ts-ignore
                                    emptyRowTempData.push(defaultRowData);
                                }
                                // @ts-ignore
                                emptyRowTempData.push(key);
                            }
                        }
                    });

                    //#.Temporarily store the new records
                    context.tempData.push(defaultRowData);

                    //#.Newly added records pushed to form data
                    if (context.pagination.pageSize == -1 || (context.formData.length <= (context.pagination.pageSize - 1))) {
                        context.formData.push(defaultRowData);
                    } else {
                        context.formData = emptyRowTempData;
                    }

                    //#.Index of empty row
                    context.emptyRowIndex = context.formData.indexOf(defaultRowData);

                    //#.Check if the new record index
                    context.editedIndex = context.formData.indexOf(defaultRowData);
                    context.editedIndexArray.push(context.editedIndex);

                    //#.formCreated event raising methods
                    // @ts-ignore
                    this.dispatch(data.payload.fileName + '/formCreated', context);
                }

                if (!context.inlineEditor.emptyRow && (data.payload.card.type == data.payload.type._grid || data.payload.card.type == data.payload.type._treeTable)) {
                    if (state[data.payload.fileName].headers.filter(x => x.type == 'Number').length > 0) {
                        state[data.payload.fileName].headers.filter(x => x.type == 'Number').forEach(key => {
                            if (!key["align"])
                                key["align"] = 'right';
                        });
                    }

                    state[data.payload.fileName].headers.push({ value: 'ButtonAction', sortable: false, type: 'Button' });
                }

                if (data.payload.card.type == data.payload.type._form) {
                    state[data.payload.fileName].editedItem = (data.payload.formData == undefined ? state[data.payload.fileName].editedItem : data.payload.formData);
                    state[data.payload.fileName].showInputs = true;
                }
            }
        } catch (e) {
            //this.commit('_logError', { payload: data.payload, message: e.message, action: '_muDownload >' });
        }
    },

    /*
        * Render title
    */
    _muRenderTitle(state, data) {
        try {
            let fields: any = {};
            let validFields: Array<any> = [];

            //#. Check for workflow implementation
            this.commit('_muWorkflowStatusApplied', { record: data });

            if (data.result.UserRigts) {
                data.payload.permissions = data.result.UserRigts;
                data.payload.contextMenu = false;
                // Bug #279861

                if (data.payload.permissions.indexOf('1') >= 0 && (data.payload.hideButtons.indexOf('Add') == -1 || data.payload.hideButtons.indexOf('Edit') == -1 || data.payload.hideButtons.indexOf('Delete') == -1))
                    data.payload.contextMenu = true;
            }

            if (data.payload.skipNullField) {
                data.payload.card.skipNullField = true;
            }

            if (data.result.Title) {
                data.payload.dashboard.menuTitle = data.result.Title.DisplayText;
                data.payload.dashboard.initialValue = data.result.Title.Value;
                data.payload.headerTooltip = data.payload.headerTooltip + ": " + data.result.Title;
            }

            if (data.result.Name) {
                data.payload.dashboard.name = data.result.Name;
                data.payload.dashboard.renderSearch = data.payload.dashboard.searchComponent;
            }

            //# Find module title index
            var index = _.findIndex(data.payload.dashboard.cards, function (index) {
                return index === data.payload.moduleName;
            });

            if (data.payload.card.type == data.payload.type._tree && data.payload.orginalFields == null) {
                // @ts-ignore
                _.forOwn(data.payload.fields, function (key, val) {
                    fields[val] = {};
                    fields[val] = key;
                    if (key.primarykey || key.parent) {
                        validFields.push(val);
                    }
                });

                if (validFields.length > 0) {
                    for (var i = 0; i < validFields.length; i++) {
                        delete data.payload.fields[validFields[i]];
                    }
                }
                data.payload.orginalFields = fields;
            }

            if (_.includes(data.payload.title, '{{')) {
                let title = data.payload.title.substr(2).slice(0, -2);

                if (data.payload.card.type == state.type._form) {
                    if (data.payload.formData)
                        data.payload.title = data.payload.formData[title];
                    else
                        data.payload.title = null;
                } else if (data.payload.formData.length > 0) {
                    data.payload.title = data.payload.formData[0][title];
                } else {
                    data.payload.title = title;
                }

                //#.using title search componets
                if (data.payload.titleSearch) {
                    data.payload.renderTitleSearchComponent = false;
                    data.payload.titleSearch = false;

                    Vue.nextTick(() => {
                        //#. Add the component back in
                        data.payload.renderTitleSearchComponent = true;
                        data.payload.titleSearch = true;
                    });
                }
            }

            if (state[data.payload.fileName].parentComponent) {
                state.dashboard.exportFileName = data.payload.title;
            }
        } catch (e) {
            // this.commit('_logError', { payload: data.payload, message: e.message, action: '_muRenderTitle >' });
        }
    },

    /*
        * Render form data
    */
    _muRender(state, data) {
        try {
            if (data.payload.card.type == data.payload.type._form) {

                if (data.payload.parentComponent) {
                    data.payload.dashboard.appTitle = data.payload.title;
                }

                let postData = {}, context = data, mapItems = {};
                // @ts-ignore
                _.forOwn(data.payload.formData, function (val, fieldName) {
                    postData[fieldName] = val;
                    mapItems[fieldName] = val;
                    if (context.payload.org[fieldName]) {
                        if (context.payload.org[fieldName].type == 'MultiSelect') {
                            let record = context.result[fieldName].Result["Value"].Record,
                                result: Array<any> = [];

                            for (var i = 0; i < record.length; i++) {
                                // if (postData[fieldName] != null && postData[fieldName].indexOf(record[i].Value) != -1) {
                                if (postData[fieldName] != null && postData[fieldName].split(",").includes(record[i].Value.toString())) {
                                    result.push({ 'DisplayText': record[i].DisplayText, 'id': record[i].Value });
                                }
                            }
                            mapItems[fieldName] = result;
                            context.payload.editedItem[fieldName] = result;
                        } else if (context.payload.org[fieldName].type == 'CheckboxList') {
                            let record = context.result[fieldName].Result["Value"].Record,
                                result = [];

                            for (var i = 0; i < record.length; i++) {
                                // if (postData[fieldName] != null && postData[fieldName].indexOf(record[i].Value) != -1) {
                                if (postData[fieldName] != null && postData[fieldName].split(",").includes(record[i].Value.toString())) {

                                    result.push(record[i].Value);
                                }
                            }
                            mapItems[fieldName] = result;
                            context.payload.editedItem[fieldName] = result;
                        } else if (context.payload.org[fieldName].type == 'ComboBox' || context.payload.org[fieldName].type == 'RadioButtonList') {
                            var record = context.result[fieldName].Result["Value"].Record;

                            for (var i = 0; i < record.length; i++) {
                                if (postData[fieldName] == record[i].Value) {
                                    mapItems[fieldName] = record[i].DisplayText;
                                    context.payload.editedItem[fieldName] = record[i].DisplayText;

                                    if (context.payload.org[fieldName].type == 'RadioButtonList') {
                                        context.payload.editedItem[fieldName] = record[i].Value;
                                    }
                                }
                            }
                        } else if (context.payload.org[fieldName].type == 'Date') {
                            let record = context.payload.org[fieldName];
                            var format = record.displayFormat || context.payload.defaultDateFormat || 'M/D/YYYY h:mm A';
                            var date = moment(val).format(format);
                            postData[fieldName] = date;
                        } else if (context.payload.org[fieldName].type == 'DateWithTime') {
                            let record = context.payload.org[fieldName];
                            var format = record.displayFormat || context.payload.defaultDateWithTime;
                            var date = moment(val).format(format);
                            postData[fieldName] = date;
                        }

                        if (context.payload.parentComponent
                            && context.payload.profile
                            && context.payload.profile.enabled
                            && context.payload.profile.fields.indexOf(fieldName) != -1
                            && context.payload.org[fieldName].type != 'MultiSelect') {

                            if (context.payload.profile.uppercase) {
                                context.payload.dashboard.uppercase = true;
                            }
                            data.payload.dashboard.appTitle = (mapItems[fieldName] == null) ? data.payload.dashboard.appTitle : (data.payload.dashboard.appTitle + context.payload.profile.separator + mapItems[fieldName]);
                        }
                    }
                });
                state[data.payload.fileName].mapItem = mapItems;
                state[data.payload.fileName].formData = postData;
            }
            state.formData = data.payload.formData;
            data.payload.copyData = data.payload.formData;

            if (state.dashboard.componentId == 0) {
                let context = state[data.payload.fileName];
                // @ts-ignore
                this.dispatch(data.payload.fileName + '/formCreated', context);
            } else {
                // @ts-ignore
                this.dispatch(data.payload.fileName + '/recordsLoaded', { state: state, data: data });
            }

            if (state.dashboard.tabularForm) {
                state[data.payload.fileName].fixedHeader = true;
            }

            if (state.dashboard.tabularForm && state[data.payload.fileName].parentComponent && _.includes(state[data.payload.fileName].orginTitle, '{{')) {
                let index = state.dashboard.tabularList.indexOf(state[data.payload.fileName].orginTitle);
                state.dashboard.tabularList[index] = state[data.payload.fileName].title;
            }
        } catch (e) {
            // this.commit('_logError', { payload: data.payload, message: e.message, action: '_muRender >' });
        }
    },

    /*
        * Common method for arrange the form layout
    */
    _muArrangeFormLayout(state, payload) {
        let totalFields, fields: Array<any> = [];
        payload.landscape = true;

        // @ts-ignore
        _.forOwn(payload.fields, function (key, val) {
            if (!key.primaryKey && key.type != 'Hidden' && !key.create && !key.parent) {
                fields.push(key.value);
            }
        });

        totalFields = fields.length;

        //Auto arrange the field layout
        if (payload.multiColumn == 'Auto') {
            if (totalFields >= 1 && totalFields <= 6) {
                payload.card.multiColumn = 1;
            } else if (totalFields >= 7 && totalFields <= 12) {
                payload.card.multiColumn = 2;
            } else if (totalFields >= 12 && totalFields <= 18) {
                payload.card.multiColumn = 3;
            } else {
                payload.card.multiColumn = 4;
            }

            payload.multiColumn = payload.card.multiColumn;
        } else {
            payload.card.multiColumn = payload.multiColumn;
        }

        if (payload.multiColumn > 2) {
            payload.landscape = false;
        }

        if (payload.inlineEditor.enabled) {
            payload.landscape = false;
        }
    },

    /*
        * Check for workflow implementation
    */
    _muWorkflowStatusApplied(state, context) {
        if (context.record.payload.parentComponent) {

            //#. Check for workflow implementation
            let workflowImplemented = context.record.payload.fields.find(x => x.value == state.workflow.workflowStepId),
                currentStatusId = 0,
                currentStatusIndex = 0;

            if (!workflowImplemented) {
                state.workflow.workflowImplemented = false;
                return;
            }

            //#. Check for workflow step is empty
            if (workflowImplemented.dropdown && workflowImplemented.dropdown.length > 0) {
                state.workflow.workflowImplemented = true;
                state.workflow.permittedOptions = workflowImplemented.dropdown;
                state.workflow.optionsList = workflowImplemented.dropdownList;
            }

            //#. Check for form type
            if (state.dashboard.componentId == 0) {
                currentStatusId = workflowImplemented.dropdown.find(x => x).Value;
                currentStatusIndex = workflowImplemented.dropdownList.findIndex(x => x.Value == currentStatusId);
                state.workflow.currentStep = currentStatusIndex;
                state.workflow.tooltipContainer = false;
                context.record.payload.editedItem[state.workflow.workflowStepId] = currentStatusId;
                return;
            }

            //#. Check for the current step id
            currentStatusId = context.record.payload.formData[state.workflow.workflowStepId];

            // @ts-ignore
            if (currentStatusId != null && currentStatusId != undefined && currentStatusId != "") {
                currentStatusIndex = workflowImplemented.dropdownList.findIndex(x => x.Value == currentStatusId);
                state.workflow.currentStep = currentStatusIndex;
            }
        }
    },


    /*
        * Commented following condition for not showing crud operation messages
    */
    _muCRUDNotificaion(context, data) {
        context.dashboard.snackbar = true;
        context.dashboard.color = "success";
        context.dashboard.requiredMsg = false; //Added by Arun

        switch (data.result.operations) {
            //Add                                                                                                                                              
            case 1:
                //Checking custom notification
                if (data.result.Message != undefined && data.result.Message != "") {
                    context.dashboard.text = data.result.Message;
                } else {
                    context.dashboard.text = context.messages.successCreate;
                }
                break;

            //Edit                                                                                                                                              
            case 2:
                //Checking custom notification
                if (data.result.Message != undefined && data.result.Message != "") {
                    context.dashboard.text = data.result.Message;
                } else {
                    context.dashboard.text = context.messages.successUpdate;
                }
                break;

            //Delete                                                                                                                                              
            case 3:
                context.dashboard.text = context.messages.successDelete;
                break;

            //Error     
            case 4:
                context.dashboard.color = "error";
                context.dashboard.text = data.result.Message;
                break;
            //Required Field  Error - Added by Arun   
            case 5:
                context.dashboard.color = "error";
                context.dashboard.text = data.result.Message;
                context.dashboard.requiredMsg = true;

                break;
        }
    },

    /*
        * Display text for tree table combobox input
    */
    _muRecurseComboBox(state, context) {
        let parent = context.parent,
            record = context.record,
            data = context.data,
            fieldName = context.fieldName;

        if (parent && parent._children) {
            for (var i = 0, l = parent._children.length; i < l; ++i) {
                let child = parent._children[i];
                child.index = i;
                let id = null;
                if (child[fieldName] || child[fieldName] == 0)
                    id = child[fieldName];
                else
                    id = (record.defaultValue == undefined) ? null : record.defaultValue;

                if (id != null || id == 0) {
                    let name = '';
                    // @ts-ignore
                    _.forOwn(data.result[fieldName].Result["Value"].Record, function (key, val) {
                        if (key.Value == id) {
                            name = key.DisplayText;
                            record.select = { DisplayText: name, Value: key.Value };
                            return;
                        }

                        if (key.Value == record.defaultValue) {
                            name = key.DisplayText;
                            record.select = { DisplayText: name, Value: key.Value };
                            return;
                        }
                    });
                    child[fieldName] = name;
                    child[fieldName + '_select'] = id;
                }
                this.commit('_muRecurseComboBox', { parent: child, data: data, record: record, fieldName: fieldName });
            }
        }
    },

    /*
        * Display text for tree table date input
    */
    _muRecurseDate(state, context) {
        let parent = context.parent,
            record = context.record;

        if (parent && parent._children) {
            for (var i = 0, l = parent._children.length; i < l; ++i) {
                var child = parent._children[i];
                if (child[record.value]) {
                    child[record.value] = moment(child[record.value]).format("MM-DD-YYYY");

                    if (record.displayFormat) {
                        child[record.value] = moment(child[record.value]).format(record.displayFormat);
                    }
                }
                // this.commit('_muRecurseDate', { parent: child, record: record });
            }
        }
    },

    /*
       * Display text for tree table number input
   */
    _muRecurseNumber(state, context) {
        let parent = context.parent,
            record = context.record;

        if (parent && parent._children) {
            for (var i = 0, l = parent._children.length; i < l; ++i) {
                var child = parent._children[i];
                if (child[record.value] != null && child[record.value] != undefined) {
                    // TODO
                    // const formatter = new Intl.NumberFormat(localRegion, {
                    //     style: 'decimal',
                    //     currency: currencyFormat,
                    //     minimumFractionDigits: (record.currency.precision == undefined ? 2 : record.currency.precision)
                    // });
                    // child[record.value] = formatter.format(child[record.value]);
                }
                // this.commit('_muRecurseNumber', { parent: child, record: record });                                      
            }
        }
    },

    /*
       * Log error
    */
    _logError(state, context) {
        context.payload.loading = false;
        context.payload.ajaxError = true;
        context.payload.ajaxMessage = context.message;
        context.payload.title = context.payload.notyTypes.error;

        if (!console) {
            return;
        }

        console.log(context.action + '> ' + context.message);
    }
}